export default __webpack_public_path__ + "static/media/aloe-vera.25e9df0b.jpg";